module.exports = __webpack_public_path__ + "static/019-f8e2402aac65dfc5b9fba23c867b77f7.jpg";